import { HttpService } from "@/core";
import {
  WorkPackagePageReq,
  WorkPackagePageResp,
  WorkPackageDetailResp,
  WorkPackageReq,
  WorkPackageSimpleListResp,
} from "./workPackage.interface";

export class WorkPackageService {
  static usePageApi() {
    const api = (params: WorkPackagePageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance/work/packages/query",
        data: params,
      });
    return HttpService.usePagination<WorkPackagePageResp>(api);
  }
  static useImportApi() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/unit/import`,
        data: {
          url,
        },
      });
    return HttpService.useRequest<void>(api);
  }
  static useSimpleListApi() {
    const api = (data = {}) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance/work/packages/queryAll",
        data,
      });
    return HttpService.useRequest<WorkPackageSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/maintenance/work/packages/queryById/${id}`,
      });
    return HttpService.useRequest<WorkPackageDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: WorkPackageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance/work/packages/save",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: WorkPackageReq) =>
      HttpService.axios({
        method: "POST",
        url: `/maintenance/work/packages/save`,
        data: { ...data, id: id },
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/maintenance/work/packages/delById/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
